<template>
  <!-- //完成 -->
  <div class="main home">
    <div style="overflow: scroll; height: 100vh">
      <div v-html="homeContent.content"></div>
    </div>

    <div class="dzHome_btn">
      <van-button type="info" block @click="toPush" size="large">
        去报名
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "hello",
  components: {},
  data() {
    return {
      homeContent: {},
    };
  },
  computed: {},
  watch: {
    $route() {},
  },

  methods: {
    toPush() {
      if (!this.$store.state.isLogin) {
        this.$router.push({ path: "/login" });
      } else {
        this.$router.push({ path: "/home" });
      }
    },

    getContent(id, key) {
      this.$api.getUser.get_agreement({ id: id }).then((res) => {
        if (res.code == 200) {
          this[key] = res.result;
        } else {
          this.$toast.fail(res.result);
        }
      });
    },
  },
  created() {
    this.getContent(5475, "homeContent");
  },
  computed: {},
  mounted() {},
};
</script>

<style lang="less">
html,
body {
  background-color: #fafafa;
}
.main {
  height: 100vh;
  overflow: hidden;
}
.dzHome_btn {
  width: 100%;
  position: absolute;
  bottom: 0;

  left: 0;
}
</style>
